import axios from "../http";

class Employee {
  //员工列表
  getEmployeeList(deptId) {
    const url = `/oa/api/employee/list?deptId=${deptId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增员工
  postAddEmployee(data) {
    const url = `/oa/api/employee/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //编辑员工
  postUpdateEmployee(data) {
    const url = `/oa/api/employee/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //删除员工
  postDelEmployee(data) {
    const url = `/oa/api/employee/del`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //修改员工状态
  postUpdateEmployeeStatus(data) {
    const url = `/oa/api/employee/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取待分配员工列表
  getEmployeeFree(name) {
    const url = `/oa/api/employee/list/free?name=${name}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //从闲置池新增员工
  postAddFreeUser(data) {
    const url = `/oa/api/employee/add/free`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //项目权限列表
  getEmployeeProjects() {
    const url = `/oa/api/employee/projects/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取员工权限
  getEmployeeAuthority(employeeId) {
    const url = `/oa/api/employee/authority/list?employeeId=${employeeId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取部门列表
  getDeptList(warehouseId) {
    const url = `/oa/api/dept/list?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //添加部门
  postAddDept(data) {
    const url = `/oa/api/dept/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //部门更新
  postUpdateDept(data) {
    const url = `/oa/api/dept/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //删除部门
  postDelDept(data) {
    const url = `/oa/api/dept/del`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //加班规则列表
  getOvertimeList(deptId) {
    const url = `/oa/api/overtime/setting/list?deptId=${deptId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增加班规则
  postUpdateOvertime(data) {
    const url = `/oa/api/overtime/setting/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //考勤天数列表
  getAttendanceList(deptId, date) {
    const url = `/oa/api/attendance/list?deptId=${deptId}&date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增考勤天数记录
  postAddAttendance(data) {
    const url = `/oa/api/attendance/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //员工每日薪资列表
  getSalaryList(page, deptId, date) {
    const url = `/oa/api/pc/salary/date/list/${page}/${deptId}?date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //员工每日薪资修改
  postSalaryModify(data) {
    const url = `/oa/api/pc/salary/date/modify`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //获取部门员工支出合计
  getSalaryCost(deptId, date) {
    const url = `/oa/api/pc/salary/cost/${deptId}?date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //重新计算员工薪资
  getSalaryRefresh(deptId, date) {
    const url = `/oa/api/pc/salary/refresh/${deptId}?date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //员工薪资列表
  getEmployeeSalaryList(page, deptId) {
    const url = `/oa/api/pc/salary/list/${page}/${deptId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //员工薪资修改
  postUpdateEmployeeSalary(data) {
    const url = `/oa/api/pc/salary/modify`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //订单复杂度规则列表
  getPickTypeList(id) {
    const url = `/oa/api/pc/pick/type/list/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 创建二维码
  postAddQrCode(data) {
    const url = `/oa/api/labor/save/relate`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 更新二维码状态
  postUpdateQrCodeStatus(data) {
    const url = `/oa/api/labor/update/relate/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 二维码列表
  getQrCodeList() {
    const url = `/oa/api/labor/list/relate`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 二维码刷新
  postQrCodeRefresh(data) {
    const url = `/oa/api/labor/refresh/qrcode`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Employee;
